// src/pages/modals/ApplicationDetailsModal.jsx
// 🔁 Полный переписанный компонент
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import axios from '../../api/axios';
import { Clipboard, FileText, Send, MessageSquare } from 'react-feather';
import ReactDOM from 'react-dom';

import './ApplicationDetailsModal.css';
import ChatBox from './ChatBox';

export default function ApplicationDetailsModal({
  selectedApplication,
  setSelectedApplication,
  downloadDecisionFile,   // оставлен на будущее использование
  generateFinalDecision,  // ✅ твоя функция
  downloadFinalDecision,  // ✅ скачать финальный документ
  token,
  t,                      // общий словарь из родителя (опционально)
  locale = 'kk',          // 'kk' | 'kz' | 'ru'
  continuationMode: continuationModeProp = null,
}) {
  /* ================= i18n ================= */
  const normalizeLocale = (v) => {
    const s = String(v || '').toLowerCase();
    if (s === 'kz') return 'kk';
    return (s === 'kk' || s === 'ru') ? s : 'kk';
  };

  const [lang, setLang] = useState(normalizeLocale(locale));

  useEffect(() => {
    setLang(normalizeLocale(locale));
  }, [locale]);

  const localTranslations = {
    kk: {
      selectFile: 'Файл таңдаңыз',
      fileUploaded: '✅ Файл сәтті жүктелді',
      uploadError: '❌ Жүктеу қатесі',
      errorOccurred: 'Қате пайда болды',
      sentSuccess: '✅ Екі педагогке жіберілді',
      sendError: 'Жіберу кезінде қате болды',
      saveSuccess: '✅ Жауап сәтті сақталды',
      saveError: 'Қате орын алды',
      notFound: 'Шешім табылмады',
      fileNotFound: 'Файл табылмады',
      fileDownloadError: 'Файлды жүктеу сәтсіз аяқталды',
      templateGenerate: 'Шаблонды генерациялау',
      templateDownload: 'Шаблонды жүктеу',
      templateGenerated: '✅ Шаблон сәтті генерацияланды',
      templateError: '❌ Шаблонды генерациялау қатесі',
      templateNotReady: 'Шаблонды жүктеу әзірленіп жатыр (бэк әлі дайын емес).',
      titleChat: 'Құжатты келісу парағы',
      tblExpert: 'Сарапшы',
      tblSubject: 'Пән',
      tblStatus: 'Статус',
      tblAvg: 'Орташа балл',
      actionsTitle: 'Қорытынды әрекеттері',
      genDoc: 'Құжатты генерациялау',
      genDocTip: 'Алдымен қорытынды құжатын, содан кейін шаблонды генерациялау',
      dlTplTip: 'Шаблонды жүктеу (бэк дайын болғанда файл келеді)',
      dlDoc: 'Құжатты жүктеу',
      uploadTitle: 'Қорытынды құжатын жүктеу',
      uploadBtn: 'Жүктеу',
      sendToTeachers: 'Педагогтерге жіберу',
      close: 'Жабу',
    },
    ru: {
      selectFile: 'Выберите файл',
      fileUploaded: '✅ Файл успешно загружен',
      uploadError: '❌ Ошибка загрузки',
      errorOccurred: 'Произошла ошибка',
      sentSuccess: '✅ Отправлено двум педагогам',
      sendError: 'Ошибка при отправке',
      saveSuccess: '✅ Ответ успешно сохранён',
      saveError: 'Произошла ошибка при сохранении',
      notFound: 'Решение не найдено',
      fileNotFound: 'Файл не найден',
      fileDownloadError: 'Ошибка загрузки файла',
      templateGenerate: 'Сгенерировать шаблон',
      templateDownload: 'Скачать шаблон',
      templateGenerated: '✅ Шаблон успешно сгенерирован',
      templateError: '❌ Ошибка генерации шаблона',
      templateNotReady: 'Скачивание шаблона ещё не доступно (бэк не готов).',
      titleChat: 'Лист согласования документа',
      tblExpert: 'Эксперт',
      tblSubject: 'Предмет',
      tblStatus: 'Статус',
      tblAvg: 'Средний балл',
      actionsTitle: 'Итоговые действия',
      genDoc: 'Сгенерировать документ',
      genDocTip: 'Сначала сгенерировать итоговый документ, затем шаблон',
      dlTplTip: 'Скачать шаблон (заработает, когда бэк будет готов)',
      dlDoc: 'Скачать документ',
      uploadTitle: 'Загрузка итогового документа',
      uploadBtn: 'Загрузить',
      sendToTeachers: 'Отправить педагогам',
      close: 'Закрыть',
    },
  };

  // приоритет: словарь из родителя (t?.[lang]) → локальный
  const tt = (t && t[lang]) || localTranslations[lang] || localTranslations.kk;

  /* ================ state ================ */
  const [experts, setExperts] = useState([]);
  const [showChatBox, setShowChatBox] = useState(false);

  const [userIsScientist, setUserIsScientist] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [attachmentId, setAttachmentId] = useState(null);
  const [attachmentReviews, setAttachmentReviews] = useState([]);
  const [comment, setComment] = useState('');
  const [alreadyReviewed, setAlreadyReviewed] = useState(false);

  const [scientistDecisionsMap, setScientistDecisionsMap] = useState({});

  const currentScientistDecisions = useMemo(
    () => scientistDecisionsMap[selectedApplication?.id] || [],
    [scientistDecisionsMap, selectedApplication?.id]
  );

  const lastDecision = useMemo(
    () => (currentScientistDecisions.length ? currentScientistDecisions[currentScientistDecisions.length - 1] : undefined),
    [currentScientistDecisions]
  );

  /* ================ helpers ================ */

  /* ===== Expert status normalize + i18n ===== */
const EXPERT_STATUS_CODES = [
  'sent',           // жіберілді / отправлено
  'accepted',       // қабылданды / принято
  'errors_detect',  // қателерді анықтау / выявление ошибок
  'errors_done',    // қате анықтау аяқталды / ошибки завершены
  'scoring',        // бағалау / оценка
  'decision',       // шешім шығару / принятие решения
  'summary',        // қорытындылау / подведение итогов
  'finished',       // аяқталды / завершено / утверждено
  'returned',       // қайтарылды / возвращено
];

function normalizeExpertStatus(statusRaw = '') {
  const s = norm(statusRaw); // твоя функция ниже в файле
  if (!s) return 'sent';

  if (s.includes('қайтар')) return 'returned';
  if (s.includes('аяқтал') || s.includes('заверш') || s.includes('бекітіл') || s.includes('утверж')) return 'finished';

  if (s.includes('қорытынды') || s.includes('итог')) return 'summary';
  if (s.includes('шешім') || s.includes('решен')) return 'decision';
  if (s.includes('бағалау аяқ') || s.includes('оценка заверш')) return 'decision';
  if (s.includes('бағалау') || s.includes('оценк')) return 'scoring';

  if (s.includes('қате анықтау аяқ') || s.includes('ошибки заверш')) return 'errors_done';
  if (s.includes('қателерді анықтау') || s.includes('выявление ошибок')) return 'errors_detect';

  if (s.includes('қабылда') || s.includes('принят')) return 'accepted';
  if (s.includes('жібер') || s.includes('отправ')) return 'sent';

  // fallback
  return 'sent';
}

const EXPERT_STATUS_LABELS = {
  kk: {
    sent: 'Жіберілді',
    accepted: 'Қабылданды',
    errors_detect: 'Қателерді анықтау',
    errors_done: 'Қателер аяқталды',
    scoring: 'Бағалау',
    decision: 'Шешім шығару',
    summary: 'Қорытындылау',
    finished: 'Аяқталды',
    returned: 'Қайтарылды',
  },
  ru: {
    sent: 'Отправлено',
    accepted: 'Принято',
    errors_detect: 'Выявление ошибок',
    errors_done: 'Ошибки завершены',
    scoring: 'Оценка',
    decision: 'Принятие решения',
    summary: 'Подведение итогов',
    finished: 'Завершено',
    returned: 'Возвращено',
  },
};

function getExpertStatusLabel(statusRaw, locale = 'kk') {
  const code = normalizeExpertStatus(statusRaw);
  const L = EXPERT_STATUS_LABELS[locale] || EXPERT_STATUS_LABELS.kk;
  return L[code] || statusRaw || '—';
}

  const norm = (s) => String(s || '').toLowerCase().trim();

  const downloadBlobResponse = (res, fallbackName = 'document.docx') => {
    const blob = new Blob([res.data], {
      type:
        res.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    const dispo = res.headers['content-disposition'] || '';
    const m = dispo.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const fileName = m ? decodeURIComponent(m[1].replace(/"/g, '')) : fallbackName;

    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  // выбираем «активный» объект решения для текущего пользователя
  const getMyActiveDecisionObj = useCallback(() => {
    const list = scientistDecisionsMap[selectedApplication?.id] || [];

    // 1) где есть мой слот и я ещё не голосовал
    const pendingForMe = list.find((x) =>
      (x.reviews || []).some((r) => r.is_my_review && !r.decision)
    );
    if (pendingForMe) return pendingForMe;

    // 2) любое «жіберілді/отправлено»
    const sent = list.find((x) =>
      ['жіберілді', 'отправлено'].includes(norm(x?.decision?.status))
    );
    if (sent) return sent;

    // 3) где вообще есть мой слот
    const withMySlot = list.find((x) =>
      (x.reviews || []).some((r) => r.is_my_review)
    );
    if (withMySlot) return withMySlot;

    // 4) fallback — первый элемент
    return list[0] || null;
  }, [scientistDecisionsMap, selectedApplication?.id]);

  const getMyReviewEntry = useCallback(
    (latest) => {
      if (!latest) return null;

      // 1) доверяем флагу
      const mineByFlag = (latest.reviews || []).find((r) => r.is_my_review);
      if (mineByFlag) return mineByFlag;

      // 2) резерв — по ID
      if (!currentUserId) return null;
      return (
        (latest.reviews || []).find(
          (r) => Number(r.reviewer_id) === Number(currentUserId)
        ) || null
      );
    },
    [currentUserId]
  );

  const postGenerateTemplateUrl = (appId) =>
    `/external-expert/applications/${appId}/template-generate`;
  const getDownloadTemplateUrl = (appId) =>
    `/external-expert/applications/${appId}/template-download`;

  /* ================ API handlers ================ */
  const handleUploadAttachment = useCallback(
    async (applicationId) => {
      if (!uploadedFile) return alert(tt.selectFile);
      const formData = new FormData();
      formData.append('file', uploadedFile);
      formData.append('application_id', applicationId);
      try {
        const res = await axios.post(
          '/external-expert/scientist-decisions/upload',
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        alert(tt.fileUploaded);
        setAttachmentId(res.data.id);
        fetchAttachmentReviews(res.data.id);
      } catch (err) {
        alert(tt.errorOccurred);
      }
    },
    [uploadedFile, token, tt]
  );

  const sendAttachmentToReviewers = useCallback(async () => {
    try {
      await axios.post(
        `/external-expert/scientist-decisions/${attachmentId}/send`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(tt.sentSuccess);
      fetchAttachmentReviews(attachmentId);
    } catch (err) {
      alert(tt.sendError);
    }
  }, [attachmentId, token, tt]);

  const fetchAttachmentReviews = useCallback(
    async (id) => {
      try {
        const res = await axios.get(
          `/external-expert/scientist-decisions/${id}/reviews`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAttachmentReviews(res.data.reviews || []);
      } catch (err) {
      }
    },
    [token]
  );

  const submitReview = useCallback(
    async (decision) => {
      try {
        await axios.post(
          `/external-expert/scientist-decisions/${attachmentId}/review`,
          { decision, comment },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        alert(tt.saveSuccess);
        fetchAttachmentReviews(attachmentId);
        setAlreadyReviewed(true);
      } catch (err) {
        alert(tt.saveError);
      }
    },
    [attachmentId, comment, token, tt]
  );

  const handleDownloadScientistDecision = useCallback(async () => {
    if (!currentScientistDecisions || currentScientistDecisions.length === 0) {
      return alert(tt.notFound);
    }
    const latestDecisionId = currentScientistDecisions[0]?.decision?.id;
    if (!latestDecisionId) return alert(tt.fileNotFound);

    try {
      const res = await axios.get(
        `/external-expert/scientist-decisions/${latestDecisionId}/download`,
        {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `ғалым-шешімі-${latestDecisionId}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert(tt.fileDownloadError);
    }
  }, [currentScientistDecisions, token, tt]);

  const handleDownloadDecisionFile = useCallback(
    (id) => {
      axios
        .get(`/external-expert/scientist-decisions/${id}/download`, {
          responseType: 'blob',
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'],
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const disposition = res.headers['content-disposition'];
          const fileName = disposition
            ? decodeURIComponent(
                disposition.split('filename=')[1]?.replace(/"/g, '') ||
                  'scientist-decision.docx'
              )
            : 'scientist-decision.docx';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => {
          alert(tt.fileDownloadError);
        });
    },
    [token, tt]
  );

  const [genBothLoading, setGenBothLoading] = useState(false);
  const [tplDownloadLoading, setTplDownloadLoading] = useState(false);

  const handleGenerateBoth = useCallback(
    async (applicationId) => {
      if (!applicationId) return;
      setGenBothLoading(true);
      try {
        // A) финал документ
        await generateFinalDecision(applicationId);

        // B) шаблон (без скачивания)
        await axios.post(
          postGenerateTemplateUrl(applicationId),
          {},
          { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' }
        );

        alert(tt.templateGenerated);
      } catch (err) {
        alert(tt.templateError);
      } finally {
        setGenBothLoading(false);
      }
    },
    [generateFinalDecision, token, tt]
  );

  const handleDownloadTemplateGET = useCallback(
    async (applicationId) => {
      if (!applicationId) return;
      setTplDownloadLoading(true);
      try {
        const res = await axios.get(getDownloadTemplateUrl(applicationId), {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        });
        downloadBlobResponse(res, `scientist-template-${applicationId}.docx`);
      } catch (err) {
        alert(tt.templateNotReady);
      } finally {
        setTplDownloadLoading(false);
      }
    },
    [token, tt]
  );

  /* ================ Effects ================ */
  // 1) первичное получение прогресса по экспертам при смене заявки
  useEffect(() => {
    if (!selectedApplication?.id) return;
    let cancelled = false;

    (async () => {
      setAttachmentId(null);
      setAttachmentReviews([]);
      try {
        const res = await axios.get(
          `/external-expert/applications/${selectedApplication.id}/progress`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (cancelled) return;

        const expertsData = res.data.experts || [];
        setExperts(expertsData);

        const currentUser = expertsData.find((e) => e.name === 'өзім');
        if (currentUser) {
          setUserIsScientist(
            norm(currentUser.academic_degree) === 'ғалым'
          );
          setCurrentUserId(currentUser.id);
        }
      } catch (err) {
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [selectedApplication?.id, token]);

  // 2) подгрузка решений по заявке (при открытии/смене и далее — интервал)
  const refreshScientistDecisions = useCallback(async () => {
    if (!selectedApplication?.id) return;
    try {
      const res = await axios.get(
        `/external-expert/scientist-decisions/by-application/${selectedApplication.id}/full`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = res.data?.data || [];
      setScientistDecisionsMap((prev) => ({
        ...prev,
        [selectedApplication.id]: data,
      }));
    } catch (e) {
    }
  }, [selectedApplication?.id, token]);

  useEffect(() => {
    if (!selectedApplication?.id) return;
    // начальная загрузка решений при открытии модалки
    refreshScientistDecisions();
  }, [selectedApplication?.id, refreshScientistDecisions]);

  useEffect(() => {
    if (!selectedApplication?.id) return;
    const interval = setInterval(() => {
      const hasSent = (scientistDecisionsMap[selectedApplication.id] || []).some(
        (x) => norm(x?.decision?.status) === 'жіберілді'
      );
      if (hasSent) refreshScientistDecisions();
    }, 10000); // каждые 10 сек

    return () => clearInterval(interval);
  }, [selectedApplication?.id, scientistDecisionsMap, refreshScientistDecisions]);

  // 3) derive: активный decision + мой слот → id вложения и флаг alreadyReviewed
  useEffect(() => {
    if (!selectedApplication?.id) return;
    const latest = getMyActiveDecisionObj();
    const mine = getMyReviewEntry(latest);

    setAttachmentId(latest?.decision?.id || null);
    setAlreadyReviewed(Boolean(mine?.decision));
  }, [
    selectedApplication?.id,
    scientistDecisionsMap,
    currentUserId,
    getMyActiveDecisionObj,
    getMyReviewEntry,
  ]);


  /* ================ derived ================ */
  if (!selectedApplication) return null;

const shouldShowUploadButton = !['жіберілді', 'қабылданды'].includes(
  norm(lastDecision?.decision?.status)
);

// если уже есть хоть одно решение — это "continuation" (доработка)
const continuationMode = continuationModeProp 
  ?? (currentScientistDecisions.length > 0 ? 'continuation' : 'new');

  

  const latestSent = getMyActiveDecisionObj();
  const mySlot = getMyReviewEntry(latestSent);

  /* ================ render ================ */
  return ReactDOM.createPortal(
    <div className="adm-backdrop" onClick={() => setSelectedApplication(null)}>
      <div className="adm-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="adm-header">
          <h3 className="adm-title">{selectedApplication.title}</h3>

          <div className="adm-toolbar">
            <button
              type="button"
              className="adm-btn adm-btn--chat"
              onClick={async () => {
                await refreshScientistDecisions();
                setAlreadyReviewed(false);
                setShowChatBox(true);
              }}
              title={tt.titleChat}
            >
              <MessageSquare size={16} className="adm-ico" />
              <span style={{ marginLeft: 6 }}>{tt.titleChat}</span>
            </button>
          </div>

          <button className="adm-close" onClick={() => setSelectedApplication(null)}>
            ×
          </button>
        </div>

        {/* Table */}
        <div className="adm-tablewrap">
          <table className="adm-table">
            <thead>
  <tr>
    <th className="px-4 py-2 border">{tt.tblExpert}</th>
    <th className="px-4 py-2 border">{tt.tblSubject}</th>
    <th className="px-4 py-2 border">{tt.tblStatus}</th>
    <th className="px-4 py-2 border">{tt.tblAvg}</th>
    {continuationMode === 'continuation' && (
      <th className="px-4 py-2 border">
        {lang === 'ru' ? 'Файл ошибок' : 'Қате файлы'}
      </th>
    )}
  </tr>
</thead>
            <tbody>
  {experts.map((exp, idx) => (
    <tr key={idx} className="hover:bg-gray-50">
      <td className="px-4 py-2 border">{exp.name}</td>
      <td className="px-4 py-2 border">{exp.subject || '—'}</td>
      <td className="px-4 py-2 border" title={exp.status || ''}>
        {getExpertStatusLabel(exp.status, lang)}
      </td>
      <td className="px-4 py-2 border">{exp.score}</td>
      {continuationMode === 'continuation' && (
        <td className="px-4 py-2 border">
          {exp.error_review_file?.url ? (
            
            <a  href={exp.error_review_file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="adm-btn adm-btn--primary"
              style={{ fontSize: 12, padding: '4px 10px' }}
            >
              📥 {lang === 'ru' ? 'Скачать' : 'Жүктеу'}
            </a>
          ) : (
            '—'
          )}
        </td>
      )}
    </tr>
  ))}
</tbody>

          </table>
        </div>

        {/* Actions */}
        {userIsScientist && (
          <div className="adm-actions">
            <h4 className="adm-subtitle">{tt.actionsTitle}</h4>
            <div className="adm-actions__row">
              <button
                className="adm-btn adm-btn--primary"
                disabled={genBothLoading}
                onClick={() => handleGenerateBoth(selectedApplication.id)}
                title={tt.genDocTip}
              >
                <Clipboard className="adm-ico" size={18} />
                {tt.genDoc}
              </button>

              <button
                className="adm-btn adm-btn--primary"
                disabled={tplDownloadLoading}
                onClick={() => handleDownloadTemplateGET(selectedApplication.id)}
                title={tt.dlTplTip}
              >
                <FileText className="adm-ico" size={18} />
                {tt.templateDownload}
              </button>

              <button
                className="adm-btn adm-btn--primary"
                onClick={() => downloadFinalDecision(selectedApplication.id)}
              >
                <FileText className="adm-ico" size={18} />
                {tt.dlDoc}
              </button>
            </div>
          </div>
        )}

        {/* Upload block (по твоей логике он показывается отдельно) */}
        {showUploadModal && (
          <div className="adm-upload">
            <h4 className="adm-subtitle">{tt.uploadTitle}</h4>
            <input
              type="file"
              accept=".doc,.docx"
              onChange={(e) => setUploadedFile(e.target.files[0])}
              className="mb-2"
            />
            <div className="adm-upload__row">
              <button
                className="adm-btn adm-btn--primary"
                onClick={() => handleUploadAttachment(selectedApplication.id)}
              >
                📤 {tt.uploadBtn}
              </button>
              <button
                className="adm-btn adm-btn--secondary"
                disabled={!attachmentId}
                onClick={sendAttachmentToReviewers}
              >
                <Send className="adm-ico" size={16} />
                {tt.sendToTeachers}
              </button>
            </div>
          </div>
        )}

        {/* Chat */}
        <ChatBox
          isOpen={showChatBox}
          onClose={() => setShowChatBox(false)}
          decisions={currentScientistDecisions}
          lang={lang}
          onDownloadDecisionFile={handleDownloadDecisionFile}
          canReview={
            Boolean(latestSent?.decision?.id) &&
            Boolean(mySlot) &&
            !mySlot.decision
          }
          currentUserId={currentUserId}
          isScientist={userIsScientist}
          allowUploadSend={userIsScientist && shouldShowUploadButton}
          applicationId={selectedApplication.id}
          token={token}
          onRefreshDecisions={refreshScientistDecisions}
          
          alreadyReviewed={alreadyReviewed}
          continuationMode={continuationMode}
          onSubmitReview={async (decision, commentText) => {
            const latest = getMyActiveDecisionObj();
            const reviewId = latest?.decision?.id;
            if (!reviewId) {
              alert(
                lang === 'kk'
                  ? 'Қате: шешім табылмады'
                  : 'Ошибка: не найден ID решения'
              );
              return;
            }
            try {
              await axios.post(
                `/external-expert/scientist-decisions/${reviewId}/review`,
                { decision, comment: commentText },
                { headers: { Authorization: `Bearer ${token}` } }
              );
              alert(tt.saveSuccess);
              await refreshScientistDecisions();
              setAlreadyReviewed(true);
            } catch (err) {
              const status = err?.response?.status;
              if (status === 403)
                alert(lang === 'kk' ? '403: Рұқсат жоқ' : '403: Нет прав');
              else if (status === 401)
                alert(lang === 'kk' ? '401: Сессия аяқталды' : '401: Сессия истекла');
              else alert(tt.saveError);
            }
          }}
        />
        </div>
    </div>,
    document.body
  );
}
